import angular from 'angular'
import byFavoritesComponent from './by-favorites.component'
import byFavoritesConfig from './by-favorites.config'
import ByFavoritesController from './by-favorites.controller'
import ByFavoritesService from './by-favorites.service'

let byFavorites = angular.module('app.byFavorites', [])
  .component('byFavorites', byFavoritesComponent)
  .controller('ByFavoritesController', ByFavoritesController)
  .service('ByFavoritesService', ByFavoritesService)
  .config(byFavoritesConfig)

export default byFavorites



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/fast-purchase/by-favorites/by-favorites.js
 **/